import React from 'react'
import InputRange from 'react-input-range'
import 'react-input-range/lib/css/index.css'
import styled from 'styled-components'
import { Brevier } from '~/components/Typography'
import { mediaqueries } from '~/utils/mediaqueries'

const StyledWrapper = styled.div`
  width: 100%;
  margin: 0 7px;

  .input-range {
    height: ${({ theme: { toRem } }) => toRem(34)};

    &__label {
      display: none;
    }

    &__track {
      margin: 0;

      ${({ theme: { color, toRem } }) => `
          background: ${color('accent', 90)};
          height: ${toRem(8)};
          border-radius: 10px;
          margin-top: -${toRem(4)};
      `}

      &--active {
        margin-top: 0;
      }
    }

    &__slider {
      ${({ theme: { color, setDimensions, toRem } }) => `
          border: 6px solid ${color('light')};
          ${setDimensions(toRem(40))};
          background: ${color('core')}
          margin-top: -${toRem(24)};
          margin-left: -${toRem(20)};
          box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
      `}

      &:active {
        transform: scale(1.1);
      }

      &-container {
        transition: none;
      }
    }
  }
`

const Label = styled(Brevier)`
  color: ${({ theme: { color } }) => color('accent')};
`

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  @media ${`${mediaqueries.sm} and ${mediaqueries.max.md}`} {
    flex: 0 0 calc(50% - 10px);
  }
`

export default ({ onChange, value, maxValue, minValue, step }) => {
  return (
    <Wrapper>
      <Label>mindre</Label>
      <StyledWrapper>
        <InputRange
          maxValue={maxValue}
          minValue={minValue}
          value={value}
          step={step}
          onChange={onChange}
        />
      </StyledWrapper>
      <Label>større</Label>
    </Wrapper>
  )
}
